import { UserModel, type IUserModel } from "models/user/shared/UserModel";


export interface IAdministratorModel extends IUserModel {

}

export class AdministratorModel extends UserModel {

 
}